var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:[
    `btn btn-${
      _vm.pinned && _vm.color === 'secondary'
        ? 'outline-secondary'
        : (_vm.pinned && _vm.color === 'outline-secondary' ? 'primary' : _vm.color)
    }`
  ],attrs:{"type":"button"},on:{"click":_vm.toggle}},[(_vm.icon)?_c('icon',{attrs:{"src":require("@/assets/icons/pin.svg")}}):[_vm._v(" "+_vm._s(_vm.$t(_vm.pinned ? 'pinboardStatus.pinned' : 'pinboardStatus.pin'))+" ")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }